import styled from "styled-components";

/**
 * A scrollable container that enables sticky CSS rendering.
 * Used as a wrapper for pages that need scrollable content.
 */
export const ScrollContainer = styled.div.attrs(() => ({
    className: "sw-layout-scrollable-element use-sticky-css-rendering",
}))`
    flex-grow: 1;
    overflow-x: auto;
`;
